import { useEffect, useState } from "react";
import { BookOpen, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useLang } from "../context/LangContext";

export default function Rules() {
  const { lang } = useLang();
  const [text, setText] = useState(null);
  useEffect(() => { api.get("/app/settings").then(({ data }) => setText(data.rules_text || "")).catch(() => setText("")); }, []);
  return (
    <div className="max-w-3xl space-y-6" data-testid="rules-page">
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold gold-text flex items-center gap-3">
        <BookOpen size={36} className="text-amber-400" /> {lang === "hi" ? "नियम और शर्तें" : "Rules & Terms"}
      </h1>
      <div className="mw-card p-6">
        {text == null
          ? <Loader2 className="animate-spin text-amber-400" />
          : <div className="whitespace-pre-line text-sm sm:text-base leading-relaxed text-slate-200" data-testid="rules-text">{text}</div>}
      </div>
    </div>
  );
}
